import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { QualifiersNotAllowedCategoryError } from "common/helpers/errors";
import { captureException } from "extensions/sentry";
import { toast } from "extensions/toast";
import { Component } from "react";
import classNames from "classnames";

import { PrimaryButton } from "common/components/buttons";

export class TextModeInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.qualifiers.toString()
        };
    }
    
    focusInput = (e) => {
        const inputEl = e.currentTarget;
        const l = inputEl.value.length;
        inputEl.setSelectionRange(l, l);
    };
    
    keypress = (e) => {
        if (e.which === 13) {
            this.applyChanges();
        }
    };
    
    applyChanges = () => {
        const str = this.state.value;
        if (Qualifiers.isValid(str)) {
            const qualifiers = this.props.qualifiers;
            qualifiers.clean();
            try {
                qualifiers.add(str);
                this.props.applyTextMode(qualifiers);
            } catch (error) {
                if (error instanceof QualifiersNotAllowedCategoryError) {
                    // Display message about invalid token
                    toast.error(`Filter ${error.extra.category} is invalid`);
                }
                captureException(error);
            }
        } else {
            toast.error("Invalid input");
        }
    };
    
    onInputChanged = (e) => {
        const value = e.currentTarget.value;
        this.setState({ value });
    };
    
    render() {
        return (
            <div className={classNames("markup", { "controls-visible": this.state.value.length })}>
                <input onChange={this.onInputChanged} onFocus={this.focusInput} onKeyPress={this.keypress} type="text" className="query-builder-text-input" value={this.state.value} placeholder="Start typing to add filters" />
                <PrimaryButton onClick={this.applyChanges} className="text-apply">Apply</PrimaryButton>
            </div>
        );
    }
}
